import { combineReducers } from 'redux';
import Articles from './store/Articles';
import NewsPosts from './store/NewsPosts';
import Book from './store/Book';
import Category from './store/Category';
import Post from './store/Post';
import Hadith from './store/Hadith';
import Auth from './store/auth';

export default combineReducers({
  Articles: Articles,
  NewsPosts: NewsPosts,
  Book: Book,
  Category: Category,
  Post: Post,
  Hadith: Hadith,
  Auth: Auth,
});
